const tax_receipts = {
  sequence: 'Tax receipt No',
};
export default tax_receipts;
